export default __webpack_public_path__ + "img/2dfedbd72699ab369c96b4bc983cf915.svg";